import { useCalculateIconSize } from '@/hooks/floor-guide';
import { useConfigStore } from '@/stores';
import { useMarkerStore } from '@/stores/markerStore';
import { mapMyLocationToMarker } from '@/utils/marker';
import type { DabeeoMap } from 'dabeeomaps';
import { useCallback, useRef } from 'react';

export const useMyCurrentLocation = (currentMap?: DabeeoMap) => {
    const server = useConfigStore((state) => state.config?.server);
    const { setMarkerIds, markerIds: markerIdsState } = useMarkerStore();
    const { calculateIconSize } = useCalculateIconSize();
    const moveToTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    const addMyCurrentLocation = useCallback(async () => {
        if (!currentMap) return;

        // Clear previous timeout nếu có
        if (moveToTimeoutRef.current) {
            clearTimeout(moveToTimeoutRef.current);
            moveToTimeoutRef.current = null;
        }

        if (markerIdsState?.myLocation) {
            currentMap?.markers?.clear?.([markerIdsState.myLocation]);
            setMarkerIds({ myLocation: undefined });
        }
        const markers = mapMyLocationToMarker(server?.floor?.floorCode, server?.machine, calculateIconSize({ width: 76, height: 76 }));
        const markerIds = await currentMap?.markers?.set?.({ marker: markers ? [markers] : [] });

        moveToTimeoutRef.current = setTimeout(() => {
            currentMap?.control?.moveTo?.({
                position: {
                    x: server?.machine?.positionX ?? 0,
                    y: server?.machine?.positionY ?? 0,
                },
                floorId: server?.floor?.floorCode,
                transition: true,
            });
            moveToTimeoutRef.current = null;
        }, 100);
        currentMap?.control?.changeZoom?.({ transition: true, zoom: server?.machine?.zoom ?? 0 });

        currentMap?.markers?.clear?.([...(markerIdsState?.poiList ?? []), ...(markerIdsState?.selectedPoi ? [markerIdsState.selectedPoi] : [])]);
        setMarkerIds({ myLocation: Array.isArray(markerIds) ? markerIds[0] : undefined, poiList: [], selectedPoi: undefined });
    }, [
        currentMap,
        server?.floor?.floorCode,
        server?.machine,
        calculateIconSize,
        setMarkerIds,
        markerIdsState?.myLocation,
        markerIdsState?.poiList,
        markerIdsState?.selectedPoi,
    ]);

    return {
        addMyCurrentLocation,
    };
};
